module.exports = __webpack_public_path__ + "static/media/twitter-gender.f38736c2.png";